import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { Switch } from '@/components/ui/switch';
import { cn } from '@/lib/cn';
import type { BaseInstance } from '@pigello/pigello-matrix';
import type { Path } from 'react-hook-form';
import type { FieldProps } from '../types';
import { DescriptionTooltip } from './description-tooltip';

export function Boolean<Instance extends BaseInstance = BaseInstance>({
  formField,
  name,
  label,
  description,
  className,
  horizontal,
  disabled,
  overrideRequired,
  canHandleField,
  onValueChange,
}: FieldProps<Instance> & { onValueChange?: (value: unknown) => void }) {
  if (horizontal) {
    return (
      <FormField
        rules={{
          required:
            (overrideRequired != null
              ? overrideRequired
              : formField.required) && 'Detta fält är obligatoriskt',
        }}
        control={formField.control}
        name={name as Path<Instance>}
        render={({ field }) => (
          <FormItem
            className={cn(
              'flex items-center justify-between space-y-0',
              className
            )}
          >
            <div className='w-1/2 shrink-0'>
              <div className='flex items-start'>
                <FormLabel>
                  {label ?? formField.label}{' '}
                  {(overrideRequired != null
                    ? overrideRequired
                    : formField.required) && <span>*</span>}
                </FormLabel>

                {(description || formField.description) && (
                  <DescriptionTooltip
                    description={description ?? formField?.description}
                  />
                )}
              </div>
              <FormMessage />
            </div>
            <div className='flex w-full items-center justify-end gap-2'>
              <FormControl>
                <Switch
                  disabled={disabled ?? field.disabled ?? !canHandleField}
                  checked={!!field.value}
                  onCheckedChange={(e) => {
                    field.onChange(e);
                    onValueChange?.(e);
                  }}
                />
              </FormControl>
            </div>
          </FormItem>
        )}
      />
    );
  }
  return (
    <FormField
      rules={{
        required:
          (overrideRequired != null ? overrideRequired : formField.required) &&
          'Detta fält är obligatoriskt',
      }}
      control={formField.control}
      name={name as Path<Instance>}
      render={({ field }) => (
        <FormItem className={className}>
          <div className='flex items-start'>
            <FormLabel>
              {label ?? formField.label}{' '}
              {(overrideRequired != null
                ? overrideRequired
                : formField.required) && <span>*</span>}
            </FormLabel>
            {(description || formField.description) && (
              <DescriptionTooltip
                description={description ?? formField.description}
              />
            )}
          </div>
          <FormControl>
            <Switch
              disabled={disabled ?? field.disabled ?? !canHandleField}
              checked={!!field.value}
              onCheckedChange={(e) => {
                field.onChange(e);
                onValueChange?.(e);
              }}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
